import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

/** @deprecated Use emailFormatValidator in combination with Angualr's email validator */
export function affiliationEmailValidator(formatStr?: string): ValidatorFn {
	return (control: AbstractControl) => {
		if (!control.value) return null;
		let passes = true;
		const domain = control.value.includes('@') ? '@' + control.value.split('@')[1] : null;

		// Make sure it is a valid email
		const validEmailErr = Validators.email(control);

		if (!formatStr || validEmailErr) {
			// If no format str provided (or it is null)
			// We only need to check the validity of the email
			return validEmailErr ? { affEmail: true } : null;
		}

		if (passes) {
			const blacklist = formatStr.charAt(0) === '!';
			// Split apart the formats and see if we are blacklisting or whitelisting
			const formats = formatStr.split('|');

			if (formats[0].charAt(0) === '!') {
				formats[0] = formats[0].substring(1);
			}

			// Search for a format that ends with inputed email
			const results = formats.find(format => domain?.toLowerCase()?.endsWith(format.toLowerCase()));

			// Passes if
			// 		It is blacklisted and we did not find a match
			//		OR
			//		It is whitelisted and we did find a match
			passes = blacklist ? !results : !!results;
		}

		return !passes ? { affEmail: true } : null;
	};
}
